"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateImageId = exports.createTextPlaceholder = exports.createSVGImageData = void 0;
var _v = _interopRequireDefault(require("uuid/v4"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createTextPlaceholder = exports.createTextPlaceholder = function createTextPlaceholder(content) {
  return "<span data-placeholder=\"true\">".concat(content, "</span>");
};
var generateImageId = exports.generateImageId = function generateImageId() {
  return (0, _v["default"])();
};
var createSVGImageData = exports.createSVGImageData = function createSVGImageData() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fileName = options.fileName,
    imageUrl = options.imageUrl,
    thumbUrl = options.thumbUrl,
    _options$operations = options.operations,
    operations = _options$operations === void 0 ? {} : _options$operations,
    _options$galleryImage = options.galleryImage,
    galleryImage = _options$galleryImage === void 0 ? true : _options$galleryImage,
    _options$isPlaceHolde = options.isPlaceHolderImage,
    isPlaceHolderImage = _options$isPlaceHolde === void 0 ? false : _options$isPlaceHolde;
  return {
    fileName: fileName,
    identifier: generateImageId(),
    originalFileName: imageUrl,
    original: {
      url: null,
      format: 'SVG',
      mimeType: 'image/svg+xml',
      width: 290,
      height: 290
    },
    preview: {
      url: imageUrl,
      format: 'SVG',
      mimeType: 'image/svg+xml',
      width: 290,
      height: 290
    },
    thumbnail: {
      url: thumbUrl,
      format: 'PNG',
      mimeType: 'image/png',
      width: 160,
      height: 160
    },
    message: null,
    gallery: galleryImage,
    isPlaceHolderImage: isPlaceHolderImage,
    operations: operations
  };
};